import { render, staticRenderFns } from "./timedActivationVIP.vue?vue&type=template&id=87e83e2c&scoped=true&"
import script from "./timedActivationVIP.vue?vue&type=script&lang=js&"
export * from "./timedActivationVIP.vue?vue&type=script&lang=js&"
import style0 from "./timedActivationVIP.vue?vue&type=style&index=0&id=87e83e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e83e2c",
  null
  
)

export default component.exports